export class TypeMontant {

  public valeur: number;

  public devise: string;

  constructor() {
    this.valeur = 0;
    this.devise = '';

  }
}
